<template>
  <div class="sales-strategy-container">
    <div class="search-container d-flex justify-end">
      <mf-search v-model="search" hide-details placeholder="Buscar produto" dense />
    </div>

    <div class="sales-strategy-container-content d-flex justify-space-between align-start mt-4">
      <div class="sales-strategy-tables">
        <header-configs :opportunities="opportunities" />
        <products-table
          v-if="opportunities.productAnalytics.length > 0"
          variant="analysis"
          :products="filteredProducts"
          :loading="loadingProductAnalytics"
          :options.sync="options"
          @remove-product="removeProduct"
        />

        <!--   <h2 class="mt-5 mb-0">Mais sugestões de produtos</h2>
        <products-table variant="suggests" /> -->
      </div>

      <boost-strategy :products="opportunities.productAnalytics" :search="search" :filters="opportunities.filters" @generate-campaign="generateCampaign" />
    </div>
  </div>
</template>

<script>
import { diacriticSpaceSensitiveRegex } from '@/helpers/search.js'
import { produtosImpulsionadores } from '../../mixins/produtos-impulsionadores'
import HeaderConfigs from '../components/Step1/HeaderConfigs.vue'
import ProductsTable from '../components/Step1/ProductsTable.vue'
import BoostStrategy from '../components/Step1/BoostStrategy.vue'
import { mapGetters } from 'vuex'
import { MUTATION_REFRESH_OPPORTUNITIES } from '../../graphql'
export default {
  name: 'Step1SalesStrategy',
  components: {
    HeaderConfigs,
    ProductsTable,
    BoostStrategy,
  },
  mixins: [produtosImpulsionadores],
  data: () => ({
    search: '',
    loadingProductAnalytics: false,
    options: {
      page: 1,
    },
    timeout: {},
  }),
  computed: {
    filteredProducts() {
      const searchRegex = diacriticSpaceSensitiveRegex(this.search)
      return this.opportunities.productAnalytics.filter(
        (productAnalytics) => productAnalytics.productName?.match(searchRegex) || productAnalytics.sku === this.search
      )
    },
    homeProducts() {
      return this.$route.params.products
    },
    ...mapGetters(['units']),
  },
  watch: {
    'opportunities.filters': {
      deep: true,
      handler() {
        this.waitAndGetData()
      },
    },
    search() {
      this.options.page = 1
    },
  },
  async mounted() {
    if (this.$route.params.products) {
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_REFRESH_OPPORTUNITIES,
          variables: {
            skus: this.$route.params.products.map((product) => product.sku),
          },
        })
      } catch (error) {
        this.$snackbar({ message: 'Erro ao atualizar oportunidades', snackbarColor: 'error' })
      } finally {
        let filters = this.opportunities.filters
        filters.products = this.$route.params.products
        this.SET_OPPORTUNITIES_KEY({ key: 'selectedProducts', payload: this.$route.params.products })
        this.SET_OPPORTUNITIES_KEY({ key: 'filters', payload: filters })
        this.waitAndGetData()
      }
    }
  },
  methods: {
    waitAndGetData() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getGroupProducts()
      }, 500)
    },
    generateCampaign(value) {
      this.$emit('generate-campaign', value)
    },
    async getGroupProducts() {
      const { currentDate, referenceDate } = this.opportunities.filters
      const units = this.opportunities.filters.units
      const products = this.opportunities.filters.products
      if (units.length < 1 || products.length < 1) {
        this.SET_OPPORTUNITIES_KEY({ key: 'productAnalytics', payload: [] })
        return
      }
      this.options.page = 1
      this.loadingProductAnalytics = true
      try {
        const variables = {
          products: products.map((product) => product.sku),
          currentInitialDate: currentDate[0],
          currentFinalDate: currentDate[1],
          referenceInitialDate: referenceDate[0],
          referenceFinalDate: referenceDate[1],
          units,
          pageSize: 0,
        }
        await this.getProductAnalytics(variables)
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar produtos.', snackbarColor: 'error' })
      } finally {
        this.loadingProductAnalytics = false
      }
    },
    removeProduct(sku) {
      const index = this.opportunities.selectedProducts.findIndex((product) => product.sku === sku)
      const productIsFromSelection = index >= 0

      if (productIsFromSelection) {
        const newSelectedProducts = this.opportunities.selectedProducts.filter((product) => product.sku !== sku)
        this.SET_OPPORTUNITIES({
          ...this.opportunities,
          selectedProducts: newSelectedProducts,
          filters: {
            ...this.opportunities.filters,
            products: [...this.opportunities.suggestedProducts, ...newSelectedProducts],
          },
        })
      }
      // FIXME: Falta implementar a remoção caso o produto seja uma sugestão
    },
  },
}
</script>

<style lang="scss" scoped>
.sales-strategy-container {
  .sales-strategy-container-content {
    gap: 20px;

    > div {
      width: 100%;
    }

    .sales-strategy-tables {
      h2 {
        color: $cinza-d10;
        font-size: 20px;
        font-weight: 600;
      }
    }
  }
}
</style>
